import { LowerCasePipe, NgClass, NgOptimizedImage, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, Input, PLATFORM_ID } from '@angular/core';
import { Card } from 'src/types/builder-components/carousel';
import { ScreenSizeService } from '../../../services/screen-size.service';

@Component({
  selector: 'app-home-top-carousel-item',
  standalone: true,
  templateUrl: './home-top-carousel-item.component.html',
  styleUrls: ['./home-top-carousel-item.styles.scss'],
  imports: [LowerCasePipe, NgClass, NgOptimizedImage],
})
export class AppHomeTopCarouselItemComponent {
  @Input() card: Card | undefined;
  @Input() isVisible: boolean = false;
  defaultImageFit: string = 'cover';
  currentImageFit: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private screenSizeService: ScreenSizeService,
  ) {
    this.currentImageFit = this.defaultImageFit;

    if (isPlatformBrowser(this.platformId)) {
      this.updateImageFit();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.updateImageFit();
    }
  }

  updateImageFit() {
    if (this.screenSizeService.isDesktop() && this.card?.card.imageBlock.desktop.imagefit) {
      this.currentImageFit = this.card?.card.imageBlock.desktop.imagefit || this.defaultImageFit;
      return;
    }

    if (this.screenSizeService.isTablet() && this.card?.card.imageBlock.tablet.imagefit) {
      this.currentImageFit = this.card?.card.imageBlock.tablet.imagefit || this.defaultImageFit;
      return;
    }

    if (this.screenSizeService.isMobile() && this.card?.card.imageBlock.mobile.imagefit) {
      this.currentImageFit = this.card?.card.imageBlock.mobile.imagefit || this.defaultImageFit;
      return;
    }

    this.currentImageFit = this.defaultImageFit;
  }
}
